import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.about": "About Us",
      "nav.news": "News",
      "nav.magazine": "Art Magazine",
      "nav.artists": "Artists",
      "nav.gallery": "Gallery",
      "nav.membership": "SPAR Membership",
      "nav.signup": "Join SPAR",
      "nav.login": "Log In",
      "nav.logout": "Log Out",
      "nav.action": "Take Action",
      "nav.media": "Media & Press",
      "nav.workshops": "Workshops",
      "nav.streetArt": "Street Art Campaign",
      "nav.mediaOffice": "Join Media Office",
      "nav.radioVoice": "Revolution Voice",
      "nav.dashboard": "My Dashboard",
      "nav.community": "Community",
      "nav.forum": "Forum",

      // Hero
      "hero.tagline": "Sudanese Plastic Artists Rally",
      "hero.subtitle": "A hub for Sudanese art, culture, and creative community",
      "hero.advertise": "Advertise Your Art Works",
      "hero.callUs": "Call Us",
      "hero.cta": "Explore Artists",

      // Search
      "search.placeholder": "Search artists, specialties...",
      "search.noResults": "No artists found",
      "search.loading": "Searching...",
      "search.viewAll": "View all results",

      // Artists
      "artists.elders": "Elder Artists",
      "artists.new": "New Artists",
      "artists.portfolio": "View Portfolio",
      "artists.loading": "Loading artists...",
      "artists.error": "Failed to load artists",
      "artists.goldenMember": "Golden Member",
      "artists.about": "About",
      "artists.specialty": "Specialty",
      "artists.contact": "Contact Info",

      // Sign Up
      "signup.title": "Create Your Artist Profile",
      "signup.subtitle": "Join the SPAR community and generate your artist card",
      "signup.profileImage": "Profile Photo",
      "signup.name": "Full Name",
      "signup.specialty": "Specialty / Art Form",
      "signup.intro": "Short Bio (max 500 characters)",
      "signup.biography": "Full Biography (max 1500 characters)",
      "signup.artworks": "Artwork Images",
      "signup.artwork": "Artwork",
      "signup.country": "Country",
      "signup.address": "Address",
      "signup.email": "Email Address",
      "signup.password": "Password",
      "signup.passwordHint": "Minimum 8 characters",
      "signup.telephone": "Phone Number",
      "signup.website": "Website (optional)",
      "signup.instagram": "Instagram Handle",
      "signup.facebook": "Facebook Profile",
      "signup.submit": "Create My Artist Card",
      "signup.submitting": "Creating your card...",
      "signup.success": "Your artist card has been created!",
      "signup.haveAccount": "Already a member?",
      "signup.loginLink": "Log in here",
      "signup.community": "SPAR Community",
      "signup.communityText":
        "By joining SPAR you'll gain access to artist tools, exhibition opportunities, and a global network of Sudanese plastic artists.",
      "signup.required": "This field is required",
      "signup.emailInvalid": "Enter a valid email address",
      "signup.passwordShort": "Password must be at least 8 characters",
      "signup.emailTaken": "An account with this email already exists",
      "signup.arabicFields": "Arabic Fields",
      "signup.arabicOptional": "(optional — helps Arabic-speaking visitors)",
      "signup.introAr": "Short Bio (Arabic)",
      "signup.biographyAr": "Full Biography (Arabic)",
      "signup.artworksHint": "Upload at least 3 artworks for your card to appear on the Artists page.",
      "signup.incompleteTitle": "Profile incomplete",
      "signup.incompleteBody": "Your account has been created, but your artist card won't appear on the Artists page until you upload at least 3 artwork images.",
      "signup.incompleteBodyAr": "تم إنشاء حسابك، لكن بطاقتك الفنية لن تظهر في صفحة الفنانين حتى ترفع صورة فنية واحدة على الأقل.",
      "signup.completeNow": "Complete Profile",
      "signup.completeLater": "Later",
      "mediaPress.title": "Artists Media & Press",
      "mediaPress.subtitle": "Videos, interviews, exhibitions and workshops",
      "editProfile.title": "Edit Profile",
      "editProfile.subtitle": "Update your artist information",
      "editProfile.saveChanges": "Save Changes",
      "editProfile.saving": "Saving...",
      "editProfile.success": "Profile updated successfully.",
      "editProfile.replaceWorks": "Replace current artworks with new ones",

      // Login
      "login.title": "Welcome Back",
      "login.subtitle": "Sign in to your SPAR account",
      "login.email": "Email or Username",
      "login.password": "Password",
      "login.submit": "Sign In",
      "login.submitting": "Signing in...",
      "login.noAccount": "Not a member yet?",
      "login.signupLink": "Create an account",
      "login.error": "Invalid email or password",
      "login.forgotPassword": "Forgot password?",

      // Forgot / reset password
      "forgot.title": "Reset Your Password",
      "forgot.subtitle": "Enter your email and we'll send you a reset link",
      "forgot.email": "Email Address",
      "forgot.submit": "Send Reset Link",
      "forgot.submitting": "Sending...",
      "forgot.sent": "If that email is registered, a reset link is on its way.",
      "forgot.backToLogin": "Back to login",
      "reset.title": "Set New Password",
      "reset.newPassword": "New Password",
      "reset.confirmPassword": "Confirm Password",
      "reset.submit": "Set Password",
      "reset.submitting": "Saving...",
      "reset.success": "Password updated! You can now log in.",
      "reset.mismatch": "Passwords do not match.",
      "reset.expired": "This reset link has expired or is invalid.",

      // Profile
      "profile.goldenMember": "Golden Member",
      "profile.about": "About",
      "profile.portfolio": "Portfolio",
      "profile.contact": "Contact",
      "profile.website": "Website",
      "profile.instagram": "Instagram",
      "profile.facebook": "Facebook",
      "profile.back": "Back to Artists",

      // Footer
      "footer.connect": "Connect with us on social media:",
      "footer.about": "Sudanese Plastic Artists Rally",
      "footer.aboutText":
        "SPAR promotes plastic art in Sudan, highlights its cultural impact, and connects Sudanese artists with the global art community.",
      "footer.services": "Our Services",
      "footer.support": "Artist Support",
      "footer.links": "Useful Links",
      "footer.contact": "Contact",
      "footer.address": "Khartoum, Sudan",
      "footer.copyright": "© 2024 Sudanese Plastic Artists Rally",

      // Dashboard
      "dashboard.loading": "Loading your dashboard…",
      "dashboard.loadErr": "Could not load your profile.",
      "dashboard.goHome": "Go Home",
      "dashboard.viewProfile": "View Public Profile",
      "dashboard.editProfile": "Edit Profile",
      "dashboard.cancelEdit": "Cancel Editing",
      "dashboard.community": "Community Board",
      "dashboard.signOut": "Sign Out",
      "dashboard.artworks": "Artworks",
      "dashboard.location": "Location",
      "dashboard.specialty": "Specialty",
      "dashboard.email": "Email",
      "dashboard.editTitle": "Edit Profile",
      "dashboard.fullName": "Full Name",
      "dashboard.country": "Country",
      "dashboard.address": "Address / City",
      "dashboard.phone": "Phone",
      "dashboard.website": "Website",
      "dashboard.instagram": "Instagram handle",
      "dashboard.facebook": "Facebook URL",
      "dashboard.shortIntro": "Short Introduction",
      "dashboard.fullBio": "Full Biography",
      "dashboard.save": "Save Changes",
      "dashboard.saving": "Saving…",
      "dashboard.cancel": "Cancel",
      "dashboard.about": "About",
      "dashboard.contactLinks": "Contact & Links",
      "dashboard.portfolio": "Portfolio",
      "dashboard.saved": "Profile updated successfully!",
      "dashboard.saveErr": "Failed to save changes.",
      "dashboard.credentials": "🔑 Login Credentials",
      "dashboard.credUsername": "Username (leave blank to keep current)",
      "dashboard.credCurrentPw": "Current Password (required to change password)",
      "dashboard.credNewPw": "New Password",
      "dashboard.credConfirmPw": "Confirm New Password",
      "dashboard.credSave": "Update Credentials",
      "dashboard.credSaving": "Saving…",
      "dashboard.credOk": "Credentials updated successfully",
      "dashboard.credErrMatch": "Passwords don't match",
      "dashboard.credErrEmpty": "Nothing to update",
      "dashboard.credErrFail": "Failed to update credentials",

      // General
      "theme.dark": "Dark mode",
      "theme.light": "Light mode",
      "lang.switch": "العربية",
      "loading": "Loading...",
      "error.generic": "Something went wrong. Please try again.",
    },
  },
  ar: {
    translation: {
      // التنقل
      "nav.home": "الرئيسية",
      "nav.about": "من نحن",
      "nav.news": "أخبار",
      "nav.magazine": "المجلة الفنية",
      "nav.artists": "الفنانون",
      "nav.gallery": "المعرض",
      "nav.membership": "عضوية SPAR",
      "nav.signup": "انضم إلى SPAR",
      "nav.login": "تسجيل الدخول",
      "nav.logout": "تسجيل الخروج",
      "nav.action": "شارك معنا",
      "nav.media": "الإعلام والصحافة",
      "nav.workshops": "ورش العمل",
      "nav.streetArt": "حملات الفن الشارع",
      "nav.mediaOffice": "انضم للمكتب الإعلامي",
      "nav.radioVoice": "صوت الثورة",
      "nav.dashboard": "لوحة التحكم",
      "nav.community": "مجلس المجتمع",
      "nav.forum": "المنتدى",

      // الصفحة الرئيسية
      "hero.tagline": "رالي الفنانين التشكيليين السودانيين",
      "hero.subtitle": "مركز الفن والثقافة والمجتمع الإبداعي السوداني",
      "hero.advertise": "أعلن عن أعمالك الفنية",
      "hero.callUs": "اتصل بنا",
      "hero.cta": "استكشف الفنانين",

      // البحث
      "search.placeholder": "ابحث عن فنان أو تخصص...",
      "search.noResults": "لا توجد نتائج",
      "search.loading": "جارٍ البحث...",
      "search.viewAll": "عرض كل النتائج",

      // الفنانون
      "artists.elders": "الفنانون الكبار",
      "artists.new": "الفنانون الجدد",
      "artists.portfolio": "عرض الأعمال",
      "artists.loading": "جارٍ التحميل...",
      "artists.error": "فشل تحميل الفنانين",
      "artists.goldenMember": "عضو ذهبي",
      "artists.about": "نبذة عن الفنان",
      "artists.specialty": "التخصص",
      "artists.contact": "معلومات التواصل",

      // التسجيل
      "signup.title": "إنشاء ملفك الفني",
      "signup.subtitle": "انضم إلى مجتمع SPAR وأنشئ بطاقتك الفنية",
      "signup.profileImage": "الصورة الشخصية",
      "signup.name": "الاسم الكامل",
      "signup.specialty": "التخصص / شكل الفن",
      "signup.intro": "مقدمة قصيرة (500 حرف كحد أقصى)",
      "signup.biography": "السيرة الذاتية الكاملة (1500 حرف كحد أقصى)",
      "signup.artworks": "صور الأعمال الفنية",
      "signup.artwork": "عمل فني",
      "signup.country": "الدولة",
      "signup.address": "العنوان",
      "signup.email": "البريد الإلكتروني",
      "signup.password": "كلمة المرور",
      "signup.passwordHint": "8 أحرف على الأقل",
      "signup.telephone": "رقم الهاتف",
      "signup.website": "الموقع الإلكتروني (اختياري)",
      "signup.instagram": "حساب إنستغرام",
      "signup.facebook": "صفحة فيسبوك",
      "signup.submit": "إنشاء بطاقتي الفنية",
      "signup.submitting": "جارٍ الإنشاء...",
      "signup.success": "تم إنشاء بطاقتك الفنية بنجاح!",
      "signup.haveAccount": "عضو بالفعل؟",
      "signup.loginLink": "سجّل دخولك هنا",
      "signup.community": "مجتمع SPAR",
      "signup.communityText":
        "بانضمامك إلى SPAR ستحصل على أدوات الفنانين وفرص المعارض وشبكة عالمية من الفنانين التشكيليين السودانيين.",
      "signup.required": "هذا الحقل مطلوب",
      "signup.emailInvalid": "أدخل بريداً إلكترونياً صحيحاً",
      "signup.passwordShort": "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
      "signup.emailTaken": "يوجد حساب مرتبط بهذا البريد الإلكتروني",
      "signup.arabicFields": "الحقول العربية",
      "signup.arabicOptional": "(اختياري — يساعد الزوار الناطقين بالعربية)",
      "signup.introAr": "نبذة قصيرة بالعربية",
      "signup.biographyAr": "السيرة الذاتية بالعربية",
      "signup.artworksHint": "ارفع 3 صور فنية على الأقل لتظهر بطاقتك في صفحة الفنانين.",
      "signup.incompleteTitle": "الملف غير مكتمل",
      "signup.incompleteBody": "تم إنشاء حسابك، لكن بطاقتك الفنية لن تظهر في صفحة الفنانين حتى ترفع 3 صور فنية على الأقل.",
      "signup.incompleteBodyAr": "تم إنشاء حسابك، لكن بطاقتك الفنية لن تظهر في صفحة الفنانين حتى ترفع 3 صور فنية على الأقل.",
      "signup.completeNow": "اكمال الملف الشخصي",
      "signup.completeLater": "لاحقاً",
      "mediaPress.title": "الإعلام والصحافة",
      "mediaPress.subtitle": "مقاطع فيديو، مقابلات، معارض وورش عمل",
      "editProfile.title": "تعديل الملف الشخصي",
      "editProfile.subtitle": "تحديث بياناتك الفنية",
      "editProfile.saveChanges": "حفظ التغييرات",
      "editProfile.saving": "جارٍ الحفظ...",
      "editProfile.success": "تم تحديث الملف الشخصي بنجاح.",
      "editProfile.replaceWorks": "استبدال الأعمال الحالية بأعمال جديدة",

      // تسجيل الدخول
      "login.title": "أهلاً بعودتك",
      "login.subtitle": "سجّل دخولك إلى حساب SPAR",
      "login.email": "البريد الإلكتروني أو اسم المستخدم",
      "login.password": "كلمة المرور",
      "login.submit": "دخول",
      "login.submitting": "جارٍ الدخول...",
      "login.noAccount": "لست عضواً بعد؟",
      "login.signupLink": "إنشاء حساب",
      "login.error": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
      "login.forgotPassword": "نسيت كلمة المرور؟",

      // نسيان / إعادة تعيين كلمة المرور
      "forgot.title": "إعادة تعيين كلمة المرور",
      "forgot.subtitle": "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين",
      "forgot.email": "البريد الإلكتروني",
      "forgot.submit": "إرسال رابط الإعادة",
      "forgot.submitting": "جارٍ الإرسال...",
      "forgot.sent": "إذا كان البريد مسجلاً، سيصلك رابط إعادة التعيين قريباً.",
      "forgot.backToLogin": "العودة إلى تسجيل الدخول",
      "reset.title": "تعيين كلمة مرور جديدة",
      "reset.newPassword": "كلمة المرور الجديدة",
      "reset.confirmPassword": "تأكيد كلمة المرور",
      "reset.submit": "حفظ كلمة المرور",
      "reset.submitting": "جارٍ الحفظ...",
      "reset.success": "تم تحديث كلمة المرور! يمكنك تسجيل الدخول الآن.",
      "reset.mismatch": "كلمتا المرور غير متطابقتين.",
      "reset.expired": "انتهت صلاحية رابط الإعادة أو أنه غير صالح.",

      // الملف الشخصي
      "profile.goldenMember": "عضو ذهبي",
      "profile.about": "نبذة",
      "profile.portfolio": "معرض الأعمال",
      "profile.contact": "التواصل",
      "profile.website": "الموقع الإلكتروني",
      "profile.instagram": "إنستغرام",
      "profile.facebook": "فيسبوك",
      "profile.back": "العودة إلى الفنانين",

      // التذييل
      "footer.connect": "تابعنا على منصات التواصل الاجتماعي:",
      "footer.about": "رالي الفنانين التشكيليين السودانيين",
      "footer.aboutText":
        "يعمل SPAR على تعزيز الفن التشكيلي في السودان وتسليط الضوء على أثره الثقافي وربط الفنانين السودانيين بالمجتمع الفني العالمي.",
      "footer.services": "خدماتنا",
      "footer.support": "دعم الفنانين",
      "footer.links": "روابط مفيدة",
      "footer.contact": "تواصل معنا",
      "footer.address": "الخرطوم، السودان",
      "footer.copyright": "© 2024 رالي الفنانين التشكيليين السودانيين",

      // لوحة التحكم
      "dashboard.loading": "جاري تحميل لوحة التحكم…",
      "dashboard.loadErr": "تعذّر تحميل ملفك الشخصي.",
      "dashboard.goHome": "الصفحة الرئيسية",
      "dashboard.viewProfile": "عرض الملف الشخصي",
      "dashboard.editProfile": "تعديل الملف الشخصي",
      "dashboard.cancelEdit": "إلغاء التعديل",
      "dashboard.community": "مجلس المجتمع",
      "dashboard.signOut": "تسجيل الخروج",
      "dashboard.artworks": "الأعمال الفنية",
      "dashboard.location": "الموقع",
      "dashboard.specialty": "التخصص",
      "dashboard.email": "البريد الإلكتروني",
      "dashboard.editTitle": "تعديل الملف الشخصي",
      "dashboard.fullName": "الاسم الكامل",
      "dashboard.country": "الدولة",
      "dashboard.address": "العنوان / المدينة",
      "dashboard.phone": "الهاتف",
      "dashboard.website": "الموقع الإلكتروني",
      "dashboard.instagram": "حساب إنستغرام",
      "dashboard.facebook": "رابط فيسبوك",
      "dashboard.shortIntro": "نبذة قصيرة",
      "dashboard.fullBio": "السيرة الذاتية الكاملة",
      "dashboard.save": "حفظ التغييرات",
      "dashboard.saving": "جارٍ الحفظ…",
      "dashboard.cancel": "إلغاء",
      "dashboard.about": "نبذة عني",
      "dashboard.contactLinks": "التواصل والروابط",
      "dashboard.portfolio": "معرض الأعمال",
      "dashboard.saved": "تم تحديث الملف الشخصي بنجاح!",
      "dashboard.saveErr": "فشل حفظ التغييرات.",
      "dashboard.credentials": "🔑 بيانات تسجيل الدخول",
      "dashboard.credUsername": "اسم المستخدم (اتركه فارغاً للإبقاء على الحالي)",
      "dashboard.credCurrentPw": "كلمة المرور الحالية (مطلوبة لتغيير كلمة المرور)",
      "dashboard.credNewPw": "كلمة المرور الجديدة",
      "dashboard.credConfirmPw": "تأكيد كلمة المرور الجديدة",
      "dashboard.credSave": "تحديث بيانات الدخول",
      "dashboard.credSaving": "جارٍ الحفظ…",
      "dashboard.credOk": "تم تحديث بيانات الدخول بنجاح",
      "dashboard.credErrMatch": "كلمتا المرور غير متطابقتين",
      "dashboard.credErrEmpty": "لا يوجد شيء للتحديث",
      "dashboard.credErrFail": "فشل تحديث بيانات الدخول",

      // عام
      "theme.dark": "الوضع الداكن",
      "theme.light": "الوضع الفاتح",
      "lang.switch": "English",
      "loading": "جارٍ التحميل...",
      "error.generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("spar-lang") || "en",
  fallbackLng: "en",
  keySeparator: false,
  interpolation: { escapeValue: false },
});

export default i18n;
